import React, { useEffect, useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';

import { SettingsState } from '../../../organisms/SelectSettings';
import { useTranslation } from 'react-i18next';
import {
  //createDefaltIoTBoxSetting,
  GetIoTBoxSettingLists,
  SetIoTSetListType,
  SetIoTSetType,
  V_IOTBOX_SETTING_ITEM,
  BATTERY_CONVERT_SET,
  GetBatteryConvertSet,
  GetMobileBatteryLevel,
  GetLithiumVoltRemainingDays,
  PutLithiumChagenDayTime,
  ApiResponseCode,
} from './IoTBoxSetting';
import { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import IoTBoxSettingRowNewDialog, { IoTBoxSettingRowNewDialogResponse } from './IoTBoxSettingRowNewDialog';
import { useModal } from '../../../../function/useModal';
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import IoTBoxSettingGridItem from './IoTBoxSettingGridItem';
import IoTBoxSettingFooter from './IoTBoxSettingFooter';
import IoTBoxSettingRowDelDialog from './IoTBoxSettingRowDelDialog';
import { GetNameDevSetList, NAME_DEV_SET } from '../../../../function/NameDevSetModel';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../atoms/Dialog/ConfirmDialog';
import SimpleDialog from '../../../atoms/Dialog/SimpleDialog';
import { TableUseStyle, IoTBoxSettingStyle } from './IoTBoxSettingStyle';

type IoTBoxSettingProps = { editData: SettingsState };

/**
 * IoTBox設定メインページ
 * @param props
 * @returns
 */
const IoTBoxSettingPage: React.FC<IoTBoxSettingProps> = (props: IoTBoxSettingProps) => {
  const tableBaseStyle = TableUseStyle();
  const pageStyle = IoTBoxSettingStyle();
  const { t } = useTranslation();

  // 設定画面リスト
  const [itemList, setItemList] = useState<V_IOTBOX_SETTING_ITEM[]>([]);
  // バッテリー情報
  const [batteryConvertList, setBatteryConvertList] = useState<BATTERY_CONVERT_SET[]>([]);
  const [selectIdx, setSelectIdx] = useState<number>(-1);
  const [devNoComboList, setDevNoComboList] = useState<ComboBoxItemType[]>([]);
  const [devNameComboList, setDevNameComboList] = useState<ComboBoxItemType[]>([]);

  // 新規登録ダイアログ
  const [flgNewRow, newRowDlg] = useModal<IoTBoxSettingRowNewDialogResponse>();
  // 削除登録ダイアログ
  const [flgDelRow, delRowDlg] = useModal<IoTBoxSettingRowNewDialogResponse>();
  // 保存確認ダイアログ
  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [dlgmsg, setDlgmsg] = useState<string>('');
  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('IoTBoxSetting.はい', 'はい')}
      cancel={t('IoTBoxSetting.キャンセル', 'キャンセル')}
    />
  ) : null;
  // エラーダイアログ
  const [messageDialogOpen, setMessageDialogOpen] = React.useState(false);
  const [showMessage, setShowMessage] = React.useState<string>(t('IoTBoxSetting.警告', '警告'));
  const [showMessageTitle, setShowMessageTitle] = React.useState<string>('');

  const [updateMap, setUpdateMap] = useState<Map<number, boolean>>(new Map<number, boolean>());

  /**
   * 設定結果
   * @param iotSetFlg
   * @returns
   */
  const getIotSetFlgRes = (iotSetFlg?: number): string => {
    //if (!btnEnable) return t('IoTBoxSettingGrid.編集不可', '編集不可');

    if (iotSetFlg == undefined) return t('IoTBoxSettingGrid.不明', '不明');

    switch (iotSetFlg) {
      case 0:
        return t('IoTBoxSettingGrid.設定中', '設定中');
      case 1:
        return t('IoTBoxSettingGrid.完了', '完了');
      case 2:
        return t('IoTBoxSettingGrid.失敗', '失敗');
      case 3: //新規追加中
        return t('IoTBoxSettingGrid.新規追加中', '新規追加中');
      case 4: //削除中
        return t('IoTBoxSettingGrid.削除中', '削除中');
      case 5: //新規追加失敗
        return t('IoTBoxSettingGrid.新規追加失敗', '新規追加失敗');
      case 6: //削除失敗
        return t('IoTBoxSettingGrid.削除失敗', '削除失敗');
      default:
        return t('IoTBoxSettingGrid.不明', '不明');
    }
  };
  /**
   * 設定ファイルULボタン表示文字
   * @param iotSetFlg
   * @returns
   */
  const getIotSetFlgDL = (iotSetFlg?: number): string => {
    if (iotSetFlg == undefined) return t('IoTBoxSettingGrid.DL未実施', 'DL未実施');
    switch (iotSetFlg) {
      case 0:
        return t('IoTBoxSettingGrid.DL中', 'DL中');
      case 1:
        return t('IoTBoxSettingGrid.DL完了', 'DL完了');
      case 2:
        return t('IoTBoxSettingGrid.DL失敗', 'DL失敗');
      case 3: //新規追加中
        return t('IoTBoxSettingGrid.DL中', 'DL中');
      case 4: //削除中
        return t('IoTBoxSettingGrid.DL中', 'DL中');
      default:
        //TODO
        return t('IoTBoxSettingGrid.DL未実施', 'DL未実施');
    }
  };

  useEffect(() => {
    //console.log('-- useEffect --');
    setSelectIdx(-1);

    props.editData.SaveFunction = saveProc;
    props.editData.IsUpdate = false;

    getData();
  }, [props.editData.CancelCondition]);

  /**
   * IoTBox設定リスト取得
   */
  const getData = () => {
    let nameDevSets: NAME_DEV_SET[] = [];
    let iotBoxSettingList: V_IOTBOX_SETTING_ITEM[] = [];
    let batteryConvertList: BATTERY_CONVERT_SET[] = [];

    GetNameDevSetList()
      .then((res) => {
        nameDevSets = res;
        return GetIoTBoxSettingLists();
      })
      .then((res) => {
        res.V_IOTBOX_SETTING_ITEMS.forEach((r) => {
          if (r.IOT_SET_FLG != null) {
            r.IOT_SET_FLG_Disp = getIotSetFlgRes(r.IOT_SET_FLG);
            r.DL_Disp = getIotSetFlgDL(r.IOT_SET_FLG);
          }
        });

        res.V_IOTBOX_SETTING_ITEMS.sort((a, b) => a.DEV_INDEX - b.DEV_INDEX);
        iotBoxSettingList = res.V_IOTBOX_SETTING_ITEMS;
        return GetBatteryConvertSet();
      })
      .then((res) => {
        batteryConvertList = res;
        iotBoxSettingList.forEach((r) => {
          r.mobileVoltLevel = GetMobileBatteryLevel(r, res);
          r.lithiumVoltRemainingDays = GetLithiumVoltRemainingDays(r);
        });
        console.debug(['iotBoxSettingList,batteryConvertList', iotBoxSettingList, batteryConvertList]);

        //機器番号リストフィルター
        nameDevSets = nameDevSets.filter((row) => {
          if (iotBoxSettingList.findIndex((row2) => row2.DEV_INDEX === row.DEV_INDEX) !== -1) {
            return true;
          }
          if (row.EST === 1) {
            return true;
          }
          return false;
        });
        setDevNoComboList(
          nameDevSets.map<ComboBoxItemType>((ci) => {
            return { index: ci.DEV_INDEX, name: ci.DEV_NO };
          })
        );
        setDevNameComboList(
          nameDevSets.map<ComboBoxItemType>((ci) => {
            return { index: ci.DEV_INDEX, name: ci.DEV_NAME };
          })
        );
        setItemList(iotBoxSettingList);
        setBatteryConvertList(batteryConvertList);
      })
      .catch((error) => {
        setShowMessageTitle(t('IoTBoxSetting.警告', '警告'));
        setShowMessage(t('IoTBoxSetting.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
        setMessageDialogOpen(true);
        console.error(['saveAction error', error]);
      })
      .finally(() => { });
  };

  /**
   * リスト編集
   * @param item
   */
  const itemUpdate = (item: V_IOTBOX_SETTING_ITEM) => {
    item.IS_EDITED = true;
    //機器番号/名称入れ替え
    const devNo = devNoComboList.find((e) => e.index == item.DEV_INDEX);
    if (devNo != undefined) item.DEV_NO = devNo.name;
    const devName = devNameComboList.find((e) => e.index == item.DEV_INDEX);
    if (devName != undefined) item.DEV_NAME = devName.name;

    const idx = itemList.findIndex((itm) => itm.IMSI_NO === item.IMSI_NO);
    //console.debug(['itemUpdate()', item, idx]);
    if (idx >= 0) {
      const temp = itemList.concat(); // 画面更新のためArrayの再生成
      temp[idx] = item;
      setItemList(temp);

      updateMap?.set(item.DEV_INDEX, true);
      setUpdateMap(updateMap);
      if (updateMap) {
        props.editData.Target = { map: updateMap, list: itemList };
        props.editData.IsUpdate = true;
      }
    }
  };

  /**
   * 画面更新ボタン
   */
  const handleupdateScreenAction = () => {
    //console.debug('updateScreenAction()');
    getData();
  };

  /**
   * 保存処理呼び出し
   * 設定ファイルUP
   * @param item
   */
  const dlRowBtnAction = (item: V_IOTBOX_SETTING_ITEM) => {
    //console.debug(['--- dlRowBtnAction ---', item]);

    //APIコール
    SetIoTSetType(item).then((status: number) => {
      //console.debug(['status', status]);
      if (status == ApiResponseCode.SUCCESS) {
        // 保存（UL）要求をレコード追加 非同期待ち
        getData();

        if (updateMap) {
          if (updateMap.has(item.DEV_INDEX)) {
            updateMap.delete(item.DEV_INDEX);
          }
          if (updateMap.size == 0) {
            props.editData.IsUpdate = false;
          }
        }
      } else {
        setShowMessageTitle(t('IoTBoxSetting.警告', '警告'));
        if (status == ApiResponseCode.SERVICE_UNAVAILABLE) {
          setShowMessage(t('IoTBoxSetting.ネットワーク接続エラー', 'ネットワーク接続エラー'));
        }
        else if (status == ApiResponseCode.DevIndexConanRegistered) {
          setShowMessage(
            t(
              'IoTBoxSetting.コナンエアー管理画面側で使用中の機器番号と重複したため中断しました\n保存する場合はデータ収集設定画面にて変換元の計測種別振動行か対象機器番号を使用しているコナンエアーの実行フラグを外すことが必要です',
              'コナンエアー管理画面側で使用中の「機器番号」と重複したため中断しました\n保存する場合は、データ収集設定画面にて変換元の計測種別『振動』行か対象機器番号を使用しているコナンエアーの実行フラグを外すことが必要です'
            )
          );
        }
        else {
          setShowMessage(t('IoTBoxSetting.設定ファイルUP実行不可', '設定ファイルUP実行不可'));
        }
        setMessageDialogOpen(true);
      }
    });
  };

  /**
   * 保存処理呼び出し
   * 一括設定ファイルUP
   */
  const dlAllBtnAction = () => {
    //UP可能なデータのみ更新
    const sendItems = itemList.filter((item) => /* item.IS_EDITED &&  */ item.DL_ENABLE);
    //console.debug(['--- dlAllBtnAction ---', itemList, 'sendItems', sendItems]);

    //APIコール
    SetIoTSetListType(sendItems).then((status: number) => {
      //console.debug(['status', status]);
      if (status == ApiResponseCode.SUCCESS) {
        // 保存（UL）要求をレコード追加 非同期待ち
        getData();

        props.editData.IsUpdate = false; // すべてアップロードした場合は編集フラグをリセット
      } else {
        setShowMessageTitle(t('IoTBoxSetting.警告', '警告'));
        if (status == ApiResponseCode.SERVICE_UNAVAILABLE) {
          setShowMessage(t('IoTBoxSetting.ネットワーク接続エラー', 'ネットワーク接続エラー'));
        } else if (status == ApiResponseCode.DevIndexConanRegistered) {
          setShowMessage(
            t(
              'IoTBoxSetting.コナンエアー管理画面側で使用中の機器番号と重複したため中断しました\n保存する場合はデータ収集設定画面にて変換元の計測種別振動行か対象機器番号を使用しているコナンエアーの実行フラグを外すことが必要です',
              'コナンエアー管理画面側で使用中の「機器番号」と重複したため中断しました\n保存する場合は、データ収集設定画面にて変換元の計測種別『振動』行か対象機器番号を使用しているコナンエアーの実行フラグを外すことが必要です'
            )
          );
        }
        else {
          setShowMessage(t('IoTBoxSetting.設定ファイルUP実行不可', '設定ファイルUP実行不可'));
        }
        setMessageDialogOpen(true);
      }
    });
  };

  /**　データ収集設定 */
  const handleCollectSettingShow = (item: V_IOTBOX_SETTING_ITEM) => {
    //console.debug('handleCollectSettingShow()', item);

    const plcParam = { plcNo: item.PLC_NO };
    props.editData.JumpMenu('Collect', plcParam);

    // if (itemList.find((itm) => itm.IS_EDITED)) {
    //   setDlgmsg('変更したデータが失われますが，\nよろしいですか？\n保存する場合は，設定ファイルDLを実行してください。');
    //   actCfmDlg
    //     .open()
    //     .apply((_) => {
    //       console.debug(['apply']);

    //       setColSetItem(item);
    //       collectSettingDsp
    //         .open()
    //         .apply(() => {
    //           //TODO データ収集設定 API実行成功後のコールバック
    //           console.debug('apply()');
    //           getData();
    //         })
    //         .cancel(() => {
    //           console.debug('cancel()');
    //         });
    //     })
    //     .cancel(() => {});
    // } else {
    //   // IoT設定 未編集
    //   setColSetItem(item);
    //   collectSettingDsp
    //     .open()
    //     .apply(() => {
    //       //TODO データ収集設定 API実行成功後のコールバック
    //       console.debug('apply()');
    //       getData();
    //     })
    //     .cancel(() => {
    //       console.debug('cancel()');
    //     });
    // }
  };

  /**　新規登録ダイアログ */
  const handleNewDialogShow = () => {
    console.debug('handleNewDialogShow()');
    newRowDlg
      .open()
      .apply(() => {
        // API実行成功後のコールバック
        console.debug('apply()');
        getData();
      })
      .cancel(() => {
        console.debug('cancel()');
      });
  };

  /**　削除登録ダイアログ */
  const handleDelDialogShow = () => {
    console.debug(['handleDelDialogShow()', itemList, selectIdx, itemList[selectIdx]?.DL_ENABLE]);

    if (selectIdx >= 0 && itemList[selectIdx].DL_ENABLE) {
      delRowDlg
        .open()
        .apply(() => {
          // API実行成功後のコールバック
          console.debug('apply()');
          getData();
        })
        .cancel(() => {
          console.debug('cancel()');
        });
    }
  };

  const saveProc = (target: object): Promise<string> => {
    return new Promise((resolve, reject) => {
      const target = props.editData.Target as { map: Map<number, boolean>; list: V_IOTBOX_SETTING_ITEM[] };

      if (target) {
        const sendItems = target.list.filter((item) => item.DL_ENABLE && target.map.has(item.DEV_INDEX));

        SetIoTSetListType(sendItems)
          .then((status: number) => {
            if (status == ApiResponseCode.SUCCESS) {
              resolve('done'); // 要求が成功すれば完了
            }
            reject('request error');
          })
          .catch((reason) => reject(reason));
      } else {
        reject('data error');
      }
    });
  };

  /**
   * リチウムバッテリ交換アクション
   * 設定ファイルUP
   * @param item
   */
  const lithiumChangeDaytimeAction = (item: V_IOTBOX_SETTING_ITEM) => {
    setDlgmsg(
      t(
        'IoTBoxSetting.バッテリ最大使用日数_残日数を更新しますか',
        'バッテリ最大使用日数，残日数を更新しますか？\n保存していないデータは破棄されます。'
      )
    );
    actCfmDlg
      .open()
      .apply((_) => {
        PutLithiumChagenDayTime(item.IMSI_NO).then((status: number) => {
          console.debug(['status', status]);
          if (status == ApiResponseCode.SUCCESS) {
            setShowMessageTitle(t('IoTBoxSetting.確認', '確認'));
            setShowMessage(
              t('IoTBoxSetting.バッテリ最大使用日数_残日数を更新します', 'バッテリ最大使用日数_残日数を更新しました')
            );
            setMessageDialogOpen(true);
            getData();
            return;
          } else {
            setShowMessageTitle(t('IoTBoxSetting.警告', '警告'));
            setShowMessage(t('IoTBoxSetting.データ更新中にエラーが発生しました', 'データ更新中にエラーが発生しました'));
            setMessageDialogOpen(true);
            console.error(['lithiumChangeDaytimeAction ApiResponseCode', status]);
          }
        });
      })
      .cancel(() => { });
  };

  //console.debug(['- 画面描画開始 -', itemList, 'selectIdx', selectIdx]);
  return (
    <>
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 2 }}>
        <Grid item xs={12}>
          <TableContainer component={Paper} className={pageStyle.tableContainer}>
            <Table stickyHeader aria-label="a dense table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell className={tableBaseStyle.headerCell} width={20}>
                    No
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={20}>
                    {t('IoTBoxSetting.自動収集', '自動収集')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={100}>
                    {t('IoTBoxSetting.機器番号', '機器番号')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={180}>
                    {t('IoTBoxSetting.機器名称', '機器名称')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={120}>
                    IMSI
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={90}>
                    {t('IoTBoxSetting.収集時刻', '収集時刻')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={100}>
                    {t('IoTBoxSetting.産業用バッテリー残量', '産業用バッテリー残量\n(%)')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={100}>
                    {t('IoTBoxSetting.リチウムバッテリ残り日数', 'リチウムバッテリ残り日数')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={100}>
                    {t('IoTBoxSetting.リチウムバッテリ最大使用日数', 'リチウムバッテリ最大使用日数')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={100}>
                    {t('IoTBoxSetting.リチウムバッテリ交換', 'リチウムバッテリ交換')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={110}>
                    {t('IoTBoxSetting.設定バージョン', '設定バージョン')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={90}>
                    {t('IoTBoxSetting.設定結果', '設定結果')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={100}>
                    {t('IoTBoxSetting.収集設定', '収集設定')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={100}>
                    {t('IoTBoxSetting.設定ファイルDL', '設定ファイルDL')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {itemList.map((item, idx) => {
                  return (
                    <IoTBoxSettingGridItem
                      rowno={idx}
                      selectIdx={selectIdx}
                      setSelectIdx={setSelectIdx}
                      item={item}
                      updateItem={itemUpdate}
                      collectSetting={handleCollectSettingShow}
                      saveRowAction={dlRowBtnAction}
                      lithiumChangeDaytimeAction={lithiumChangeDaytimeAction}
                      devNoLists={devNoComboList}
                      devNameLists={devNameComboList}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        <Grid item xs={12}>
          <IoTBoxSettingFooter
            items={itemList}
            onClickUpdateScreenButton={handleupdateScreenAction}
            onClickAllDLButton={dlAllBtnAction}
            onClickNewButton={handleNewDialogShow}
            onClickDelButton={handleDelDialogShow}
          ></IoTBoxSettingFooter>
        </Grid>

        {/* IoTBox新規登録 */}
        {flgNewRow ? <IoTBoxSettingRowNewDialog dialog={newRowDlg} /* devNoCombos={devNoComboList} */ /> : null}
        {/* IoTBox削除 */}
        {flgDelRow ? <IoTBoxSettingRowDelDialog dialog={delRowDlg} item={itemList[selectIdx]} /> : null}
        {/* 収集設定画面遷移 */}
        {cfmdlg}
        {/* エラーダイアログ */}
        <SimpleDialog
          open={messageDialogOpen}
          onClose={() => setMessageDialogOpen(false)}
          title={showMessageTitle}
          okText={'OK'}
          maxWidth={'sm'}
        >
          <Typography>{showMessage}</Typography>
        </SimpleDialog>
      </Grid>
    </>
  );
};

export default IoTBoxSettingPage;
